import React from 'react';
import { Box } from '@applyboard/ui-components';
import { ChartExportMenu } from "./ChartExportMenu";
import { StyledChartFiltersWrapper, StyledChartHeaderContent, StyledChartHeaderSubtitle, StyledChartHeaderTitle } from "./styles";
export var ChartHeader = function ChartHeader(_ref) {
  var chartAppliedFilters = _ref.chartAppliedFilters,
    chartSubtitle = _ref.chartSubtitle,
    chartTitle = _ref.chartTitle,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(StyledChartHeaderContent, null, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(StyledChartHeaderTitle, null, chartTitle), chartSubtitle && /*#__PURE__*/React.createElement(StyledChartHeaderSubtitle, null, chartSubtitle)), /*#__PURE__*/React.createElement(StyledChartFiltersWrapper, null, children && children, /*#__PURE__*/React.createElement(ChartExportMenu, {
    chartAppliedFilters: chartAppliedFilters,
    chartSubtitle: chartSubtitle,
    chartTitle: chartTitle
  })));
};